'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocale = getLocale;

var _index = require('./index');

/**
 * 通过语言包 key 获取文案
 * @param {string} localeKey  语言包 key 值
 * @param {object} values     替换变量的键值对 key 是变量名，value 是变量值
 * @return {string}           不存在则返回 localeKey
 */
function getLocale() {
  var localeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var values = arguments[1];

  if (typeof window === 'undefined') return;
  var intl = window.__intl__;
  if (!intl && !(intl = (0, _index.getIntlText)())) {
    return;
  }

  if (typeof localeKey !== 'string') localeKey = localeKey.toString();

  var messages = intl.messages;
  var value = (0, _index.getObj)(messages, localeKey);

  return value ? formatMessage(value, values) : localeKey;
}

exports.default = getLocale;


function formatMessage(message, values) {
  var out = message;
  Object.keys(values || {}).forEach(function (key) {
    var reg = '{\\s*' + key + '\\s*}';
    out = out.replace(new RegExp(reg, 'g'), values[key]);
  });
  return out;
}